
import { Vue, Component, Prop } from 'vue-property-decorator'
import AccountMenu from '@mg/web-components/Account/AccountMenu'
import { GQLMenu, GQLUser } from '~/graphql/__generated__/interfaces'
import getVipIcon from '~/utils/getVipIcon'
import { getMenuGQL, MENU_TYPE } from '@mg/micro/data/gql/menu'

@Component({
  components: {
    AccountMenu,
  },
  apollo: {
    getMenu: {
      query: getMenuGQL,
      variables() {
        const DEFAULT_MENU_TYPE = MENU_TYPE.KC
        const preview = this.$route.query.naviPreview as string
        const abTestVersion = this.$shopConfig.abTests.abTestsData.menuAbTest
        const fullMenu = false

        if (preview) {
          const previewParams = preview.split('|')
          return {
            abTestVersion,
            fullMenu,
            menuType: previewParams[0],
            menuVersion: previewParams[1],
          }
        }

        return {
          abTestVersion,
          fullMenu,
          menuType: DEFAULT_MENU_TYPE,
        }
      },
    },
  },
})
export default class TheAccountMenu extends Vue {
  getMenu: GQLMenu

  @Prop({ type: Object }) user: GQLUser
  getVipIcon = getVipIcon

  get translations() {
    return {
      hdg_widget_is_vip: this.$t('common.hdg_widget_is_vip'),
      logout: this.$t('common.logout'),
    }
  }

  async logout(event: Event) {
    event.preventDefault()
    await this.$webApi.logout()
    window.location.replace('/')
  }
}
